/**
 * GTM Events Utility Module
 * Centralizes dataLayer.push calls for Google Tag Manager
 */

/**
 * Push event to GTM dataLayer
 * @param {string} eventName - Event name
 * @param {Object} eventData - Additional event data
 */
export function pushGTMEvent(eventName, eventData = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...eventData
  });
}

/**
 * Track modal open
 * @param {string} modalName - Name of the modal
 */
export function trackModalOpen(modalName) {
  pushGTMEvent('modal_open', { modal_name: modalName });
}

/**
 * Track modal close
 * @param {string} modalName - Name of the modal
 */
export function trackModalClose(modalName) {
  pushGTMEvent('modal_close', { modal_name: modalName });
}

/**
 * Track form submission
 * @param {string} formName - Name of the form
 * @param {boolean} success - Whether submission was successful
 */
export function trackFormSubmit(formName, success) {
  pushGTMEvent('form_submit', { form_name: formName, success });
}

/**
 * Track CTA button click
 * @param {string} ctaText - Button text
 * @param {string} ctaLocation - Where on page (e.g., 'hero', 'footer')
 */
export function trackCTAClick(ctaText, ctaLocation) {
  pushGTMEvent('cta_click', { cta_text: ctaText, cta_location: ctaLocation });
}

/**
 * Track FAQ accordion expand
 * @param {string} question - The FAQ question text
 */
export function trackFAQExpand(question) {
  pushGTMEvent('faq_expand', { question });
}

/**
 * Track language switch
 * @param {string} fromLang - Previous language code
 * @param {string} toLang - New language code
 */
export function trackLanguageSwitch(fromLang, toLang) {
  pushGTMEvent('language_switch', { from_lang: fromLang, to_lang: toLang });
}
